import {SET_FILTER, SET_FILTERS, CLEAR_FILTERS} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function filterReducer(state = initialstate.filter, action) {
	switch (action.type) {
		case SET_FILTERS: {
			if (action.filter) {
				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						[action.filter.name]: {
							...action.filter,
							value: action.value
						}
					}
				};

				if (!Utility.hasValue(result[action.key][action.filter.name].value)) {
					delete result[action.key][action.filter.name].value;
				}

				if (!Utility.hasValue(result[action.key][action.filter.name].value)) {
					delete result[action.key][action.filter.name];
				}

				result.isLoaded = true;

				return result;
			} else {
				return {
					...state,
					[action.key]: action.value
				};
			}
		}

		case CLEAR_FILTERS: {
			if (!action.parentName) {
				if (action.selectedKey) {
					return {...state, [action.key]: {...state[action.key], [action.selectedKey]: {}}};
				} else {
					return {...state, [action.key]: {}};
				}
			} else {
				let result = {...state[action.key]};

				Object.entries(result).forEach((filter) => {
					if (
						!filter[1].appliesTo ||
						(filter[1].appliesTo && filter[1].appliesTo.some((item) => item === action.parentName))
					) {
						delete result[filter[0]];
					}
				});

				return {
					...state,
					[action.key]: result
				};
			}
		}
		case SET_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				value = null;
			}

			let filters;
			if (!action.parentName) {
				filters = {...state.filters};
				if (action.filterKey) {
					if (filters[action.filterKey]) {
						filters[action.filterKey] = {...filters[action.filterKey]};
					} else {
						filters[action.filterKey] = {};
					}

					filters[action.filterKey][action.filterItemName] = value;
				} else {
					filters[action.filterItemName] = value;
				}

				let result = {...state};
				return {
					...result,
					filters
				};
			} else {
				let specific = {};
				if (state[action.parentName]?.filters.specific) {
					specific = {...state[action.parentName].filters.specific};
				}
				specific[action.filterItemName] = value;
				return {
					...state,
					[action.parentName]: {
						filters: {
							...state[action.parentName]?.filters,
							specific
						}
					}
				};
			}
		}

		default:
			return state;
	}
}
